// 导入 React 核心库
import React from 'react';
// 导入 ReactDOM 客户端渲染库
import ReactDOM from 'react-dom/client';
// 导入全局样式文件
import './index.css';
// 导入 App 组件
import App from './App';

// 获取 HTML 中的 root 元素，并将其转换为 HTMLElement 类型
// 这是 React 应用的挂载点，所有内容都会渲染到这个元素中
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// 使用 React.StrictMode 包裹 App 组件
// StrictMode 是一个用于突出显示应用程序中潜在问题的工具
// 它不会渲染任何可见的 UI，但会激活额外的检查和警告
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 